import { inject, Service } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AdGateConstants } from '@adgate/common/constants/adgate.constants';
import { StateService } from './state-service';

@Service()
export class ModuleActivationService
{
    private stateService: StateService = inject(StateService);
    private activeModuleSubject: BehaviorSubject<number> = new BehaviorSubject<number>(AdGateConstants.MODULE_DASHBOARD);

    /**
     * Observable of the currently active module.
     * Emits the current value immediately to new subscribers.
     */
    public activeModule$: Observable<number> = this.activeModuleSubject.asObservable();

    /**
     * Get the current active module value synchronously
     */
    public getCurrentModule(): number
    {
        return this.activeModuleSubject.value;
    }

    /**
     * Activate a specific module.
     * All subscribers will be notified of the change.
     */
    public activateModule(moduleId: number): void
    {        
        this.activeModuleSubject.next(moduleId);

        switch(moduleId) {
        case AdGateConstants.MODULE_DASHBOARD:
            this.stateService.navigate('/main/dashboard');
            break;
        case AdGateConstants.MODULE_LINEAR:
            this.stateService.navigate('/main/tv');
            break;
        case AdGateConstants.MODULE_STREAMING:
            this.stateService.navigate('/main/streaming');
            break;
        case AdGateConstants.MODULE_PRODUCTION:
            this.stateService.navigate('/main/production');
            break;
        case AdGateConstants.MODULE_ADMINPANEL:
            this.stateService.navigate('/main/admin');
            break;
        default:
            this.stateService.navigate('/main/dashboard');
            break;
        }
    }
}
